import { FC } from 'react';
import { Link } from '@tanstack/react-router';
import { Stack } from '@mui/material';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import Icon from '../icon';
import Text from '../text';
import { IconType } from '../icon/helpers';
import { FlatButtonSize, getFlatButtonIconSize, useFlatButtonStyles } from '../flat-button/helpers';

interface Props {
  label: string;
  icon?: IconType;
  to: string;
  search?: Record<string, string>;
  hash?: string;
  size?: FlatButtonSize;
}

const useStyles = createUseStyles({
  flatLink: {
    display: 'inline-flex',
    verticalAlign: 'middle',
  },
});

const FlatLink: FC<Props> = ({ label, icon, to, search, hash, size = 'medium' }) => {
  const flatStyles = useFlatButtonStyles();
  const styles = useStyles();
  const IconEl = icon ? <Icon name={icon} size={getFlatButtonIconSize(size)} /> : null;

  return (
    <Link to={to} search={search} hash={hash} className={styles.flatLink}>
      <Stack
        className={classNames(flatStyles.flatButton, 'link')}
        flexDirection="row"
        alignItems="center"
        gap={1}
      >
        {IconEl}
        <Text size={size}>{label}</Text>
      </Stack>
    </Link>
  );
};

export default FlatLink;
